export const DEBOUNCE_TIME = 1000; //delay 1000ms
export enum GET_SOLUTION_RESPONSE_STATUS {
  OK = 'OK',
  NO_OUTPUT = 'NO_OUTPUT',
}
